import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

const token = () => localStorage.getItem('customerToken') || ''

// Los errores de regla llegan como {code, message[, product]}.
const detalle = (error, porDefecto) => {
    const d = error.response?.data?.detail
    if (!d) return { code: null, message: porDefecto }
    if (typeof d === 'string') return { code: null, message: d }
    return { code: d.code || null, message: d.message || porDefecto, product: d.product }
}

// FastAPI store: POST /api/v1/store/orders/place?token=...
export const place_order = createAsyncThunk(
    'order/place_order',
    async({ price, products, shipping_fee, items, shippingInfo, userId, payment_method, payment_ref, navigate }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(`/orders/place?token=${token()}`, {
                price, products, shipping_fee, items, shippingInfo, userId, payment_method, payment_ref
            })
            navigate('/payment', {
                state: { price: price + shipping_fee, items, orderId: data.orderId,
                         paymentMethod: payment_method,
                         promisedDate: data.promisedDate, pendientesProveedor: data.pendientesProveedor || [] }
            })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(detalle(error, 'No se pudo crear el pedido'))
        }
    }
)

// Checkout con reserva temporal (ECO-06). Agregar al carrito no reserva; al
// entrar a la página de envío se reservan las líneas por unos minutos.
const checkoutThunk = (nombre, metodo, ruta) => createAsyncThunk(
    `order/${nombre}`,
    async(_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api[metodo](`${ruta}?token=${token()}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(detalle(error, 'No se pudo validar la disponibilidad'))
        }
    }
)
export const checkout_start  = checkoutThunk('checkout_start',  'post', '/checkout/start')
export const checkout_status = checkoutThunk('checkout_status', 'get',  '/checkout/status')
export const checkout_cancel = checkoutThunk('checkout_cancel', 'post', '/checkout/cancel')
export const checkout_renew  = checkoutThunk('checkout_renew',  'post', '/checkout/renew')

// FastAPI store: GET /api/v1/store/orders/{customerId}/{status}?token=...
export const get_orders = createAsyncThunk(
    'order/get_orders',
    async({ customerId, status }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.get(`/orders/${customerId}/${status}?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// FastAPI store: GET /api/v1/store/orders/detail/{orderId}?token=...
export const get_order_details = createAsyncThunk(
    'order/get_order_details',
    async(orderId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const token = localStorage.getItem('customerToken') || ''
            const { data } = await api.get(`/orders/detail/${orderId}?token=${token}`)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const orderReducer = createSlice({
    name: 'order',
    initialState: {
        myOrders: [],
        errorMessage: '',
        successMessage: '',
        myOrder: {},
        // Reserva del checkout: { active, expires_at, seconds_left, ttl_minutes, reservations, pendientes_proveedor }
        checkout: null,
        checkoutError: null,     // { code, message, product }
        checkoutLoading: false,
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
            state.checkoutError = null
        },
        checkoutClear: (state) => { state.checkout = null; state.checkoutError = null }
    },
    extraReducers: (builder) => {
        builder
        .addCase(place_order.rejected, (state, { payload }) => {
            state.checkoutError = payload
            state.errorMessage = payload?.message || 'No se pudo crear el pedido'
        })
        .addCase(checkout_start.pending, state => { state.checkoutLoading = true })
        .addCase(checkout_start.fulfilled, (state, { payload }) => { state.checkoutLoading = false; state.checkout = payload; state.checkoutError = null })
        .addCase(checkout_start.rejected, (state, { payload }) => { state.checkoutLoading = false; state.checkout = null; state.checkoutError = payload })
        .addCase(checkout_renew.pending, state => { state.checkoutLoading = true })
        .addCase(checkout_renew.fulfilled, (state, { payload }) => { state.checkoutLoading = false; state.checkout = payload; state.checkoutError = null })
        .addCase(checkout_renew.rejected, (state, { payload }) => { state.checkoutLoading = false; state.checkout = null; state.checkoutError = payload })
        .addCase(checkout_status.fulfilled, (state, { payload }) => { state.checkout = payload })
        .addCase(checkout_cancel.fulfilled, (state) => { state.checkout = null })
        .addCase(get_orders.fulfilled, (state, { payload }) => {
            state.myOrders = payload?.orders || []
        })
        .addCase(get_order_details.fulfilled, (state, { payload }) => {
            state.myOrder = payload?.order || {}
        })
    }
})

export const { messageClear, checkoutClear } = orderReducer.actions
export default orderReducer.reducer
